import { Skeleton } from '../../ui/skeleton'
import React from 'react'

export const AddItemSkeleton = () => {
  return (
    <div className="rounded-xl border border-black/10 bg-white px-4">
      <div className="border-b border-black/10 py-4 flex items-center justify-between">
        <div>
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-32" />
          </div>
          <Skeleton className="mt-1 h-3 w-36" />
        </div>
        <Skeleton className="h-7 w-7 rounded-full" />
      </div>
      <div className="divide-y divide-black/10">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between py-4">
            <div className="flex min-w-0 items-center gap-3">
              <div className="min-w-0">
                <Skeleton className="h-4 w-40" />
                <Skeleton className="mt-1 h-3 w-28" />
              </div>
            </div>
            <Skeleton className="h-8 w-24 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  )
}
